import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, forkJoin, from, map, of, switchMap } from 'rxjs';

import { DataRepository } from '@core/data/data-repository';
import { ProjectSettingsApiActions, ProjectSettingsPageActions } from './project-settings.actions';

/**
 * Bridges Project Settings actions to the data layer. Loads the attribute lists
 * and activity catalog together; edits stay in the reducer (session-only).
 */
@Injectable()
export class ProjectSettingsEffects {
  private readonly actions$ = inject(Actions);
  private readonly repo = inject(DataRepository);

  readonly load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectSettingsPageActions.entered),
      switchMap(() =>
        forkJoin({
          attributes: from(this.repo.listProjectAttributes()),
          catalog: from(this.repo.listActivityCatalog()),
        }).pipe(
          map(({ attributes, catalog }) => ProjectSettingsApiActions.loadSuccess({ attributes, catalog })),
          catchError((err: unknown) =>
            of(ProjectSettingsApiActions.loadFailure({ error: toMessage(err) })),
          ),
        ),
      ),
    ),
  );
}

function toMessage(err: unknown): string {
  return err instanceof Error ? err.message : 'Unknown error';
}
